export const TIA_EVENT_SLUG = "teacher-impact-awards-edition-4"
